jQuery(function () {

})

global.modules.set({
  async init(context) {
    $('.news-post .btn-edit', context).on('click', function () {
      var elem = $(this);
      var parent = elem.closest('.news-post');
      parent.addClass('editing');
      var text = parent.find('.text-news');
      parent.find('textarea').height(text.height()).val(text.text());
    })

    validateForm({
      selector: 'form.save_post',
      rules: {
        body: {
          required: true,
          minlength: 15
        },
      },
      // submitHandler: function (e) {
      //   const formData = new FormData($(this)[0]);
      //   $.ajax({
      //     url: form.attr('action'),
      //     data: formData,
      //     headers: {
      //       "X-XSRF-TOKEN": document.cookie.split('XSRF-TOKEN=')[1].split(';')[0]
      //     },
      //     method: form.attr('method'),
      //     elem: parent,
      //     success: function (data) {
      //       if (!data.success) {
      //         showNotificationPopup(data.message, 'error);
      //       } else {
      //         parent.removeClass('editing');
      //         text.text(textarea.val());
      //       }
      //     }
      //   });
      // }
    })
    $('form.save_post', context).on('reset', function () {
      parent.removeClass('editing');
    })
  }
})